import { useState, useEffect, useCallback } from 'react';
import { API, authAxios } from './adminApi';

// Admin session: 24h JWT held in an httpOnly cookie set by the backend.
export const useAdminAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [checkingAuth, setCheckingAuth] = useState(true);
  const [loginError, setLoginError] = useState('');
  const [loginLoading, setLoginLoading] = useState(false);

  useEffect(() => {
    authAxios.get(`${API}/admin/verify-token`)
      .then(() => setIsAuthenticated(true))
      .catch(() => {})
      .finally(() => setCheckingAuth(false));
  }, []);

  const handleLogin = async (loginForm) => {
    setLoginLoading(true);
    setLoginError('');
    try {
      await authAxios.post(`${API}/admin/login`, loginForm);
      setIsAuthenticated(true);
    } catch (err) {
      setLoginError(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoginLoading(false);
    }
  };

  const dropSession = useCallback(() => {
    authAxios.post(`${API}/admin/logout`).catch(() => {});
    setIsAuthenticated(false);
  }, []);

  return { isAuthenticated, checkingAuth, loginError, loginLoading, handleLogin, handleLogout: dropSession, dropSession };
};
